"use client"
import { Container, CTAButton, ContentWrapper, CTAContainer, Subheadline, Headline } from '@/components/ui'
import GradientContainer from '@/components/ui/GradientContainer'
import MediaContainer from '@/components/ui/MediaContainer'
import { useCTAUrl } from '@/lib/use-cta-url'
import { GradientVariant, HeadlineVariant } from '@/types/ui'
import { usePageSettings } from '@/components/contexts/PageSettingsContext'

interface HyperAIProps {
  gradientVariant?: GradientVariant
  headlineVariant?: HeadlineVariant
  title?: string
  subtitle?: string
}

const HyperAI = ({ 
  gradientVariant = '12', 
  headlineVariant,
  title = "Your AI Co-Worker Is Already Here.",
  subtitle = "While others talk about AI agents, your team already has one. \nHyperAI lives in your projects, understands context, and works alongside you, no setup required."
}: HyperAIProps) => {
  const { enableHyperAIGoogleLogin, showGoogleLogoHyperAI } = usePageSettings()
  const {href: ctaUrl, isCalendly} = useCTAUrl()
  return (
    <Container variant="section">
        <ContentWrapper gap="lg">
          <Headline variant={headlineVariant}>{title}</Headline>
          <Subheadline htmlContent={true}>
          {subtitle}
          </Subheadline>
          
          <GradientContainer gradientVariant={gradientVariant} variant="fullscreen">
            <MediaContainer 
              src="/images/features/HyperAI.avif" 
              type="image"
              alt="Dictation Functions"
              className='md:max-w-[75%]'
              
            />
          </GradientContainer>
           
          {/* CTA Button */}
          <CTAContainer marginTop="sm">
            <CTAButton
              href={ctaUrl}
              variant="primary"
              size="lg"
              enableGoogleLogin={enableHyperAIGoogleLogin && !isCalendly}
              showGoogleLogo={showGoogleLogoHyperAI}
              external={ctaUrl.startsWith('http')}
            >
              Get Started
            </CTAButton>
          </CTAContainer>
        </ContentWrapper>
      </Container>
  )
}

export default HyperAI